<template>
    <div>
        <div class="p-2 border border-primary-subtle bg-white mb-2">
            <strong><T>supportBanner.statement</T></strong>
            <br class="d-md-none">
            <T>supportBanner.links</T>
        </div>
    </div>
</template>
